import React from 'react';
import { getRandomElement } from '../../../functions/utils';
import { _ } from '../../../functions/translator';

class UsersList extends React.Component{

    render(){

        let usersInCharge = _('Usuarios a cargo')
        if (this.props.customcard) {
            if (!this.props.customcard.attributes.users_in_charge) return <div></div>
            usersInCharge = this.props.customcard.attributes.users_in_charge
        }

        let users = []
        if (window.is_demo) {
            for (let i = 0; i < Object.keys(this.props.card.users_in_charge).length; i++) {
                let demoUserName = getRandomElement(window.demo_user_names)
                let demoRole = getRandomElement(window.position_roles)
                users.push(<div><span className='text card-description'>{demoUserName + ' - ' + demoRole}</span></div>)
            }
        } else {
            for(const user of Object.values(this.props.card.users_in_charge)){
                let userName = user.attributes.first_name +' '+ user.attributes.last_name
                if (user.attributes.position) {
                    userName += ' - ' + user.attributes.position
                }
                users.push(<div><span className='text card-description'>{userName}</span></div>)
            }
        }
        if (users.length === 0) users.push(<span className='text card-description'>{_('Ninguno')}</span>)

        return (
            <div>
                <div className='info-container'>
                    <p className='card-text'>{ usersInCharge }</p>
                    {users}
                </div>
            </div>
        );

    }
}

export default UsersList;